import React from 'react'

// tremor 
import { Flex, Title } from "@tremor/react";

// bootstrap
import { Button } from "react-bootstrap";

// custom components
import { CustomSpinner } from "_atoms";

// redux
import { useSelector, useDispatch } from "react-redux";
import { setSelectedTimeline, selectDeleteTimelineAreaStatus, selectSelectedTimeline, deleteTimelineArea } from "_redux/slices/timeline/timeline-areas";

//styles
import { Colors, Spacing } from "_styles";
const DeleteTimelinearea = ({ closeModal }) => {

    //#region redux
    const dispatch = useDispatch();

    const deleteTimelineAreaStatus = useSelector(selectDeleteTimelineAreaStatus);
    const selectedTimeLine = useSelector(selectSelectedTimeline)

    //#endregion

    //#region functions
    const confirmDelete = () => {
        const data = { id: selectedTimeLine._id }
        dispatch(deleteTimelineArea(data))
        dispatch(setSelectedTimeline(null));
    }

    //#endregion

    return (
        <div>
            <div>
                <p style={{ margin: 0, padding: 0, fontSize: "18px", height: "24px" }}>
                    <span style={{ fontWeight: "bold" }}>{selectedTimeLine?.title}</span>&nbsp;
                    will be deleted. Are you sure?
                </p>
            </div>
            <div style={{ marginTop: Spacing.SCALE_22 }}>
                <Flex>
                    <Button variant={"outline-primary"} onClick={confirmDelete}>
                        {deleteTimelineAreaStatus === 'loading' ? <CustomSpinner /> : "Delete"}
                    </Button>
                    <Button variant={"outline-danger"} onClick={closeModal}>
                        Cancel
                    </Button>
                </Flex>
            </div>
        </div>
    )
}

export default DeleteTimelinearea
